module.exports = __webpack_public_path__ + "static/box-closed-b1e1de524234f3e56a48c78d9035e04a.png";